<template>
  <v-layout
    mt-5
    mb-8
    ml-2
    wrap
  >
    <v-flex
      v-for="(m, i) in userModules"
      :key="i"
      xs12
      pt-0
      pb-0
    >
      <v-checkbox
        v-model="form.modules"
        color="primary"
        :value="m.id"
      >
        <template
          v-slot:label
        >
          <span>
            <b>{{ m.name }}</b><br>
            <small>({{ m.description }})</small>
          </span>
        </template>
      </v-checkbox>
    </v-flex>
    <v-flex
      v-if="error"
      xs12
    >
      <small class="text-danger">{{ $t('whitelabel.chooseModule') }}</small>
    </v-flex>
  </v-layout>
</template>

<script>

import USER_MODULES from '@/graphql/queries/UserModules.gql';

export default {
  name: 'WhiteLabelModules',
  props: {
    editForm: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      error: false,
      form: {
        modules: [],
      },
    };
  },
  watch: {
    editForm(value) {
      if (value) {
        this.form.modules = []
        this.editForm.modules.forEach(item => {
          this.form.modules.push(item.id)
        })
      }
    },
    form: {
      handler(value) {
        if (value.modules.length > 0) {
          this.error = false
        } else {
           this.error = true
        }
      },
      deep: true
    },
  },
  apollo: {
    userModules: {
      fetchPolicy: "network-only",
      query() {
        return USER_MODULES;
      },
      result({loading, data: { userModules }}) {
        if (!loading) {
          if (this.form.modules.length == 0 && userModules.length > 0) {
            this.form.modules.push(userModules[0].id)
          }
        }
      }
    },
  },
  methods: {
    save() {
      if (this.error) {
        return
      }
      let form = {
        modules:  []
      }
      this.$emit('saveForm', this.form);
    }
  },
};
</script>

<style lang="scss"></style>
